import { render, staticRenderFns } from "./ViewAttribute.vue?vue&type=template&id=2596f250&scoped=true"
import script from "./ViewAttribute.vue?vue&type=script&lang=js"
export * from "./ViewAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596f250",
  null
  
)

export default component.exports